import { IconSelect } from '@/lib/crm/utils/icons/IconSelect';

import type { PropertyInputProps } from './TextInput';

export const IconSelectInput: React.FC<PropertyInputProps> = ({
  propertyType,
  value,
  onChange,
  disabled = false,
  placeholder,
}) => {
  return (
    <IconSelect
      value={typeof value === 'string' ? value : null}
      onChange={onChange}
      isDisabled={disabled}
      placeholder={placeholder ?? `Select ${propertyType.label.toLowerCase()}`}
      aria-label={propertyType.label}
    />
  );
};
